import React, { useEffect } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import MyCoupon from './components/myCoupons';
import Login from './components/loginScreen';
import HomePage from './components/homePage';
import Register from './components/register';
import AllCooupon from './components/allCoupon';
import Transaction from './components/transaction';
import PromotionConfirm from './components/promotionConfirmPage';
import BuyCoupon from './components/buySuccess';
import Promtion from './components/promotionPage';
import Guest from './components/guest';
import Account from './components/account';
import EarnPoints from './components/earnPoints';
import { useSettings } from './hooks/useSettings';
import { CircularProgress, Box } from '@mui/material';

const AppLoader: React.FC = () => (
  <Box 
    display="flex" 
    justifyContent="center" 
    alignItems="center" 
    minHeight="100vh"
  >
    <CircularProgress />
  </Box>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/homePage",
    element: <HomePage />,
  },
  {
    path: "/registerPage",
    element: <Register />,
  },
  {
    path: "/mycoupons",
    element: <MyCoupon />,
  },
  {
    path: "/allcoupons",
    element: <AllCooupon />,
  },
  {
    path: "/transaction",
    element: <Transaction />,
  },
  {
    path: "/Promotionconfirm",
    element: <PromotionConfirm />,
  },
  {
    path: "/buycoupon",
    element: <BuyCoupon />,
  },
  {
    path: "/promotion",
    element: <Promtion />,
  },
  {
    path: "/guest",
    element: <Guest />,
  },
  {
    path: "/account",
    element: <Account />,
  },
  {
    path: "/earnPoints",
    element: <EarnPoints />,
  },
]);

function App() {
  const { loading } = useSettings();

  if (loading) {
    return <AppLoader />;
  }

  return <RouterProvider router={router} />;
}

export default App;